"use client";

import React from "react";
import { message, Modal } from "antd";
import { programsStudentModuleTechniqueAcademy } from "../../../../shared/services";

const { confirm } = Modal;

export interface UseDeleteQualificationStudentProps {
  onSuccess?: () => void;
}

export default function useDeleteQualificationStudent({
  onSuccess,
}: UseDeleteQualificationStudentProps = {}) {
  const [loading, setLoading] = React.useState(false);

  const showDeleteConfirm = (valId: number, val?: string) => {
    if (!valId) {
      message.error("Ocurrió un error");
      return;
    }

    const label = val?.trim() || `registro #${valId}`;

    confirm({
      title: `¿Borrar la calificación con id ${valId}?`,
      content: `Una vez ejecutada esta acción no hay vuelta atrás. Estás por borrar "${label}". Si deseas continuar, haz clic en "Borrar calificación"; de lo contrario, pulsa "Cancelar".`,
      okText: "Borrar calificación",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        setLoading(true);
        try {
           await programsStudentModuleTechniqueAcademy.remove(valId).then(()=> {
            message.success(
              `Se ha borrado con éxito la calificación con id: ${valId}`
            );
            onSuccess?.();
          });
        } catch (err) {
          console.error(err);
          message.error("Error al borrar la calificación del estudiante.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {},
    });
  };

  return { showDeleteConfirm, loading };
}
